import React, { useState } from "react";
import { Link } from "react-router-dom";

const AllProductsGrid = ({ products }) => {
  const [selectedCategory, setSelectedCategory] = useState("Tümü");

  const categories = ["Tümü", "Kupa", "Vazo"];

  const filteredProducts =
    selectedCategory === "Tümü"
      ? products
      : products.filter((product) => product.category === selectedCategory);

  return (
    <section className="px-6 py-16 bg-gradient-to-b from-white to-gray-50 relative">
      <h2 className="text-3xl font-bold text-center mb-8">Tüm Ürünler</h2>

      {/* Kategori Butonları */}
      <div className="flex justify-center gap-4 mb-10">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
              selectedCategory === cat
                ? "bg-stone-900 text-white"
                : "bg-stone-200 text-stone-700 hover:bg-stone-300"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Ürün Grid */}
      <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3 max-w-6xl mx-auto">
        {filteredProducts.map((product) => (
          <div
            key={product.id}
            className="bg-white rounded-xl shadow-md overflow-hidden transform hover:scale-105 hover:shadow-lg transition-all duration-300 opacity-0 animate-fadeIn"
          >
            <Link to={`/products/${product.id}`}>
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-56 object-contain bg-gray-100"
              />
            </Link>
            <div className="p-4">
              <Link to={`/products/${product.id}`}>
                <h3 className="text-lg font-semibold hover:underline">{product.name}</h3>
              </Link>
              <p className="text-sm text-gray-500">{product.category}</p>
              <p className="text-sm text-gray-600 mt-2">{product.description}</p>
            </div>
          </div>
        ))}
      </div>

      {filteredProducts.length === 0 && (
        <p className="text-center text-gray-500 mt-10">Bu kategoriye ait ürün bulunamadı.</p>
      )}
    </section>
  );
};

export default AllProductsGrid;
